import { useEffect } from "react";
import L from 'leaflet';
import { useMap } from "react-leaflet";
import 'leaflet-measure/dist/leaflet-measure.css';
import 'leaflet-measure/dist/leaflet-measure';
import { colors } from "../../helpers/colors";

export function RTFOMapMeasureControl() {
  const map = useMap();

  useEffect(() => {

    L.Control.Measure.include({
      // set icon on the capture marker
      _setCaptureMarkerIcon: function () {
        // disable autopan
        this._captureMarker.options.autoPanOnFocus = false;
    
        // default function
        this._captureMarker.setIcon(
          L.divIcon({
            iconSize: this._map.getSize().multiplyBy(2)
          })
        );
      },
    });

    const measure = L.control.measure({
      position: 'topleft',
      primaryLengthUnit: 'kilometers',
      secondaryLengthUnit: 'miles',
      primaryAreaUnit: 'hectares',
      secondaryAreaUnit: 'acres',
      activeColor: '#db4a29', // color for active polygon
      completedColor: colors[0],
      captureZIndex: 10000
      }).addTo(map);

      return () => {
        map.removeControl(measure);
      };
}, [map]);

  return null;
};